import { render, staticRenderFns } from "./GoToChatStaff.vue?vue&type=template&id=30bb1e24&"
import script from "./GoToChatStaff.vue?vue&type=script&lang=js&"
export * from "./GoToChatStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports